import React from 'react'
import styled from 'styled-components'
import {
  Box, Loader,
} from '@usap/uicomponents'
import { Title } from '../meta'

const borderStyle = {
  side: 'bottom',
  size: 'xsmall',
  color: 'light-3',
}

const StyledSelectBoxTitle = styled(Box)`
  width: 100%;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 220px;
  }
`

const SelectBoxTitle = ({
  loading,
  option,
  index,
}) => {
  if (loading) {
    return <Loader width="24px" height="24px" />
  }

  return (
    <StyledSelectBoxTitle
      id={`option-${index}-${option.toString().replace(/ /g, '-')}`}
      key={option}
      pad="medium"
      border={borderStyle}
    >
      <Title size="small" label={option} />
    </StyledSelectBoxTitle>
  )
}

export default SelectBoxTitle
